import React, { useState } from "react";
import Modal from "components/base/Modal";
import classNames from "classnames";
import css from "../style.scss";
import { useDispatch } from "react-redux";

const AdminSetup = ({ isOpen, content, onClose, onSuccess, integrationId }) => {
  const dispatch = useDispatch();
  const [showToast, setShowToast] = useState(false);

  const [isSubmitting, setIsSubmitting] = useState(false);

  return (
    <div className={css.clsNewCallSettingSection}>
      <Modal
        isOpen={isOpen}
        onClose={onClose}
        uniqId="AdminSetupRequired"
        width="auto"
        padding="0"
        zIndex={998}
        modalClassName={css.pricingModal}
        className={classNames(css.clsAccPageModals, css.clsBillingModal)}
      >
        <div className={classNames(css.modal_lg, "modal-dialog modal-lg m-0 modal-dialog-scrollable")}>
          <div className={classNames(css.clsModalContent, "modal-content")}>
            <div className={classNames(css.removeBatchDialerModal, "modal-body")}>
              <div className={css.rbModalTextGroup}>
                <div className={css.rbModalTitle}>Admin Setup Required</div>
                <div className={css.rbModalDetails}>
                  {content ? (
                    <span className={css.lineBreak}>{content}</span>
                  ) : (
                    <>
                      To use this feature, your account admin must have<br />
                      an active Lead Automator subscription. Please<br />
                      contact your admin for assistance.
                    </>
                  )}
                </div>
              </div>

              <div className={css.buttonRemoveWrapper}>
                <button className={classNames(css.connectBtn, { [css.noClick]: isSubmitting })} onClick={onSuccess}>
                  <span className={css.connectBtnLabel}>Ok</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default AdminSetup;